import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// 引入全局样式
import './styles/index.css'

// 移动端适配
import 'amfe-flexible'

// Vant 组件全局注册
import {
  Button,
  NavBar,
  Popup,
  Icon,
  Loading,
  Empty,
  Toast,
  Dialog,
  Checkbox,
  CheckboxGroup,
  Cell,
  CellGroup,
  Field,
  Form,
  Image as VanImage,
  Divider,
  Tag,
  List,
  PullRefresh,
  Swipe,
  SwipeItem,
  Tab,
  Tabs,
  ActionSheet,
  Picker,
  DatetimePicker,
  Overlay,
  Badge,
  Switch,
  Stepper,
  Search,
  Grid,
  GridItem
} from 'vant'

const vantComponents = [
  Button, NavBar, Popup, Icon, Loading, Empty, Toast, Dialog,
  Checkbox, CheckboxGroup, Cell, CellGroup, Field, Form, VanImage,
  Divider, Tag, List, PullRefresh, Swipe, SwipeItem, Tab, Tabs,
  ActionSheet, Picker, DatetimePicker, Overlay, Badge, Switch,
  Stepper, Search, Grid, GridItem
]

vantComponents.forEach(component => Vue.use(component))

Toast.setDefaultOptions({ duration: 2000 })

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
